"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Percentage["default"];
  }
});
var _Percentage = _interopRequireDefault(require("./Percentage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }